<template>
  <header class="header">
    <div class="site-topbar">
      <div class="container">
        <div class="topbar-nav">
          <div class="logo-box" @click="handleSelect('/home')">
            <img src="@/assets/img/logo.png" alt="logo"/>
          </div>
          <div :class="['menu-item', isIncludesPath(item.path) ? 'active-menu-item' : '']"
               v-for="item in menuData"
               :key="item.meta.title"
               @click="handleSelect(item.path)">
            <span>
              {{ item.meta.title }}
            </span>
            <span>
              {{ item.meta.titleEn }}
            </span>
          </div>
          <div class="login-content" v-if="!isUserInfo">
            <router-link to="/login">登录 Sign In</router-link>
          </div>
          <div class="login-content" v-else>
            <span class="userinfo-span">
              <el-dropdown trigger="hover">
                <span class="el-dropdown-link">
                  <span>{{ userInfo.mobileLike }}</span>
                  <i class="el-icon-arrow-down el-icon--right"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item @click.native="myprofile">
                    <div class="personal-menu">
                      <span>
                      个人中心
                    </span>
                    <span>
                      Personal center
                    </span>
                    </div>
                  </el-dropdown-item>
                  <el-dropdown-item divided @click.native="logout">
                    <div class="personal-menu">
                      <span>
                      退出登录
                    </span>
                    <span>
                      Log out
                    </span>
                    </div>
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </span>
          </div>
        </div>
      </div>
    </div>
  </header>
</template>

<script>
export default {
  props: {},
  data() {
    return {
      activePath: "",
      userInfo: {},
      isUserInfo: false,
      menuData: []
    };
  },
  mounted() {
    let userInfo = JSON.parse(localStorage.getItem("webUserInfo"));
    if (userInfo) {
      this.isUserInfo = true;
      this.userInfo = userInfo;
    }
    this.activePath = this.$route.path;
    this.getTenantService();
  },
  computed: {},
  components: {},
  methods: {
    handleSelect(val) {
      this.activePath = val;
      if (val === '/room') {
        // 客房
        const dateStart = this.$utils.getFormatDate(new Date(new Date().getTime() + 24*60*60*1000), 'yyyy-MM-dd');
        const dateEnd = this.$utils.getFormatDate(new Date(new Date().getTime() + 24*60*60*1000*2), 'yyyy-MM-dd');
        this.$router.push(`${val}/?startTime=${dateStart}&endTime=${dateEnd}`);
        return;
      }
      this.$router.push(val);
    },
    async getTenantService() {
      let menuData = this.$_.cloneDeep(this.$router.options.routes.filter((v) => !v.hidden));
      try {
        let {data} = await this.$api.getTenantService();
        const homeFunctionCodes = JSON.parse(data.homeFunctionCodes) || [];
        const checkCodes = homeFunctionCodes.filter(item => item.isCheck == 1)
        const names = checkCodes.map((item) => item.name);

        // if (!names.includes('酒店配套')) {
        //   menuData = menuData.filter(v => !v.name || v.name.indexOf('facilities') == -1);
        // }
        // if (!names.includes('资讯中心')) {
        //   menuData = menuData.filter(v => v.name != 'news');
        // }
        const customize = ['酒店配套', '会议设施', '餐饮与其他设施','商城', '客房']
        menuData = menuData.filter(item => {
          const title = item.meta.title;
          //酒店配套被拆分成了：餐饮与其他设施、会议设施
          const aliasIndex = names.findIndex(name => name == title)
          if (aliasIndex != -1 ) {
            const checkCode = checkCodes[aliasIndex]
            const aliasName = checkCode.aliasName
            const englishAliasName = checkCode.englishAliasName
            if (!this.$_.isEmpty(aliasName)) {
              item.meta.title = aliasName;
            }
            if (!this.$_.isEmpty(englishAliasName)) {
              item.meta.titleEn = englishAliasName;
            }
          }
          return aliasIndex != -1||title==customize[3]||title==customize[4]||(names.includes(customize[0])&&(title==customize[1]||title==customize[2]));
        })

        this.menuData = menuData;
      } catch (error) {
        console.log(error);
      }
    },

    isIncludesPath(path) {
      return this.activePath.indexOf(path) > -1;
    },
    //个人中心
    myprofile: function () {
      this.$router.push("/my-profile");
    },
    //退出登录
    logout: function () {
      this.$confirm("确认退出吗?", "提示", {
        //type: 'warning'
      })
          .then(() => {
            localStorage.removeItem("WEBTOKEN");
            localStorage.removeItem("webUserInfo");
            this.$router.push("/login");
          })
          .catch(() => {
          });
    },
  },
  watch: {
    $route() {
      this.activePath = this.$route.path;
    }
  },
};
</script>

<style lang="scss" scoped>
.site-topbar {
  background: #333333;
  width: 100%;
  position: relative;
  box-sizing: border-box;
  display: block;

  .container {
    width: 1350px;

    .topbar-nav {
      display: flex;
      display: -webkit-flex;
      display: -o-flex;
      display: -ms-flex;
      display: -moz-flex;
      position: relative;
      box-sizing: border-box;
      align-items: center;
      height: 84px;
      width: 100%;
      overflow: hidden;

      .menu-item {
        margin-right: 20px;
        font-size: 15px;
        font-weight: bold;
        color: rgba(255, 255, 255, 0.4);
        line-height: 1.3rem;
        cursor: pointer;
        display: flex;
        display: -webkit-flex;
        display: -o-flex;
        display: -ms-flex;
        display: -moz-flex;
        flex-direction: column;
        -ms-flex-direction: column;
        -webkit-flex-direction: column;
        align-items: center;
        justify-items: center;
        position: relative;
        box-sizing: border-box;
        flex-shrink: 1;
        -webkit-flex-shrink: 1;

        span {
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }

        &:hover {
          color: #fff;
        }

        &.menu-item:last-child {
          margin-right: 0;
        }

        &.active-menu-item {
          color: #fff;
        }
      }

      .logo-box {
        width: 146px;
        margin-right: 30px;
        cursor: pointer;
        flex-shrink: 0;
        -webkit-flex-shrink: 0;

        img {
          width: 100%;
        }
      }

      .login-content {
        width: fit-content;
        cursor: pointer;
        margin-left: auto;
        flex-shrink: 0;
        -webkit-flex-shrink: 0;

        a {
          font-size: 15px;
          font-weight: bold;
          color: rgba(255, 255, 255, 1);
          line-height: 84px;
        }

        .userinfo-span {
          .el-dropdown-link {
            font-size: 15px;
            font-weight: bold;
            color: rgba(255, 255, 255, 1);
            line-height: 84px;
          }
        }
      }
    }
  }

}

.personal-menu {
  display: flex;
  flex-direction: column;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  align-items: center;
  justify-content: center;

  span {
    line-height: 1.3rem;
  }
}

.header {
  position: sticky;
  position: -webkit-sticky;
  top: 0;
  z-index: 100;
}
</style>
